import { deserialize, DocumentObject } from '@jsonapiworld/jsonapi-serializer';
import { backendApiGateway } from '~/client/backend';
import {
  CompareUserData,
  GenerateUserBankAccountTokenUrlResponse,
  UserBankAccount,
  UserBankAccountFilters,
} from '~/types/user-bank-account';
import {
  buildJsonAPIQueryParams,
  jsonAPICursorPaginatorBuilder,
  jsonAPIFilterBuilder,
  jsonAPIIncludeBuilder,
} from '~/utils/jsonapi-query';

export const fetchUserBankAccounts = async ({
  companyId,
  source,
  statuses,
  userId,
}: UserBankAccountFilters): Promise<UserBankAccount[]> => {
  const filtersBuilder = jsonAPIFilterBuilder();
  filtersBuilder.eq('bankAccount.company.id', companyId);
  filtersBuilder.eq('source', source);
  if (statuses) filtersBuilder.in('status', statuses);
  if (userId) filtersBuilder.eq('user.id', userId);
  const includeBuilder = jsonAPIIncludeBuilder(['user', 'bankAccount']);
  const paginatorBuilder = jsonAPICursorPaginatorBuilder({ size: 100 });
  const { data } = await backendApiGateway.get<DocumentObject>('/api/v1/user-bank-accounts', {
    params: buildJsonAPIQueryParams(filtersBuilder, includeBuilder, paginatorBuilder),
  });

  return deserialize<UserBankAccount>(data) as UserBankAccount[];
};

export const generateUserBankAccountTokenUrl = async ({
  id,
  includeEmail,
}: {
  id: UserBankAccount['id'];
  includeEmail: boolean;
}) => {
  const { data } = await backendApiGateway.post<GenerateUserBankAccountTokenUrlResponse>(
    `/api/v1/user-bank-accounts/${id}/generate-token-url`,
    { include_email: includeEmail },
  );
  return data.url;
};

export const fetchCompareUserData = async (id: UserBankAccount['id']): Promise<CompareUserData> => {
  const { data } = await backendApiGateway.get<CompareUserData>(`/api/v1/user-bank-accounts/${id}/compare-user-data`);
  return data;
};
